import { ObjectDefinitions } from "../types/ObjectDefinitionTypes";

const objects: ObjectDefinitions[] = [
  {
    name: "yeast_beaker",
    image: "yeast_beaker_w_spoon",
    type: "interactableObject",
    defaultState: "beaker__spoon",
    states: [
      {
        name: "beaker",
        image: "yeast_beaker",
      },
      {
        name: "beaker__spoon",
        image: "yeast_beaker_w_spoon",
      },
    ],
  },
  {
    name: "sugar_beaker",
    image: "sugar_beaker_w_spoon",
    type: "interactableObject",
    defaultState: "beaker__spoon",
    states: [
      {
        name: "beaker",
        image: "sugar_beaker",
      },
      {
        name: "beaker__spoon",
        image: "sugar_beaker_w_spoon",
      },
    ],
  },
  {
    name: "graduated_cylinder",
    image: "graduated_cylinder",
    type: "controllableObject",
    defaultState: "empty",
    states: [
      {
        name: "empty",
        image: "graduated_cylinder",
      },
      {
        name: "filled",
        image: "graduated_cylinder_w_water",
      },
      {
        name: "emptied",
        image: "graduated_cylinder",
      },
    ],
  },
  {
    name: "incubator",
    image: "incubator_closed",
    type: "interactableObject",
    defaultState: "closed",
    states: [
      {
        name: "closed",
        image: "incubator_closed",
        buttons: [
          {
            icon: "door_open_icon",
            title: "Open door",
            stateUpdates: [{ nextState: "open" }],
            type: "UpdateState",
          },
        ],
      },
      {
        name: "closed__flask_mixed__balloon_deflated",
        image: "incubator_closed_deflated",
        buttons: [
          {
            icon: "door_open_icon",
            title: "Open door",
            stateUpdates: [
              { nextState: "open__flask_mixed__balloon_deflated" },
            ],
            type: "UpdateState",
          },
        ],
      },
      {
        name: "closed__flask__balloon_deflated",
        image: "incubator_closed_inflated",
        buttons: [
          {
            icon: "door_open_icon",
            title: "Open door",
            stateUpdates: [{ nextState: "open__flask__balloon_deflated" }],
            type: "UpdateState",
          },
        ],
      },
      {
        name: "closed__flask_yeast_sugar_water__balloon_partially_inflated",
        image: "incubator_closed_partially_inflated",
        buttons: [
          {
            icon: "door_open_icon",
            title: "Open door",
            stateUpdates: [
              {
                nextState:
                  "open__flask_yeast_sugar_water__balloon_partially_inflated",
              },
            ],
            type: "UpdateState",
          },
        ],
      },
      {
        name: "closed__flask_yeast_sugar_water__balloon_deflated",
        image: "incubator_closed_flask_unmixed",
        buttons: [
          {
            icon: "door_open_icon",
            title: "Open door",
            stateUpdates: [
              { nextState: "open__flask_yeast_sugar_water__balloon_deflated" },
            ],
            type: "UpdateState",
          },
        ],
      },
      {
        name: "closed__flask_mixed__balloon_inflated",
        image: "incubator_closed_empty_flask",
        buttons: [
          {
            icon: "door_open_icon",
            title: "Open door",
            stateUpdates: [
              { nextState: "open__flask_mixed__balloon_inflated" },
            ],
            type: "UpdateState",
          },
        ],
      },
      {
        name: "closed__flask_yeast_water__balloon_deflated",
        image: "incubator_closed_no_sugar",
        buttons: [
          {
            icon: "door_open_icon",
            title: "Open door",
            stateUpdates: [
              { nextState: "open__flask_yeast_water__balloon_deflated" },
            ],
            type: "UpdateState",
          },
        ],
      },
      {
        name: "closed__flask_yeast_sugar__balloon_deflated",
        image: "incubator_closed_no_water",
        buttons: [
          {
            icon: "door_open_icon",
            title: "Open door",
            stateUpdates: [
              { nextState: "open__flask_yeast_sugar__balloon_deflated" },
            ],
            type: "UpdateState",
          },
        ],
      },
      {
        name: "closed__flask_sugar_water__balloon_deflated",
        image: "incubator_closed_no_yeast",
        buttons: [
          {
            icon: "door_open_icon",
            title: "Open door",
            stateUpdates: [
              { nextState: "open__flask_sugar_water__balloon_deflated" },
            ],
            type: "UpdateState",
          },
        ],
      },
      {
        name: "closed__flask_sugar__balloon_deflated",
        image: "incubator_closed_sugar",
        buttons: [
          {
            icon: "door_open_icon",
            title: "Open door",
            stateUpdates: [
              { nextState: "open__flask_sugar__balloon_deflated" },
            ],
            type: "UpdateState",
          },
        ],
      },
      {
        name: "closed__flask_water__balloon_deflated",
        image: "incubator_closed_water",
        buttons: [
          {
            icon: "door_open_icon",
            title: "Open door",
            stateUpdates: [
              { nextState: "open__flask_water__balloon_deflated" },
            ],
            type: "UpdateState",
          },
        ],
      },
      {
        name: "closed__flask_yeast__balloon_deflated",
        image: "incubator_closed_yeast",
        buttons: [
          {
            icon: "door_open_icon",
            title: "Open door",
            stateUpdates: [
              { nextState: "open__flask_yeast__balloon_deflated" },
            ],
            type: "UpdateState",
          },
        ],
      },
      {
        name: "open",
        image: "incubator_open",
        buttons: [
          {
            icon: "door_open_icon",
            title: "Open door",
            stateUpdates: [{ nextState: "closed" }],
            type: "UpdateState",
          },
        ],
      },
      {
        name: "open__flask_mixed__balloon_deflated",
        image: "incubator_open_deflated",
        buttons: [
          {
            icon: "eject_flask_icon",
            title: "Remove flask",
            stateUpdates: [
              { nextState: "open" },
              {
                nextState: "flask_mixed__balloon_red",
                objectId: "flask3",
              },
            ],
            type: "UpdateState",
            actionName: "EJECT_FLASK_FROM_INCUBATOR",
          },
          {
            icon: "door_close_icon",
            title: "Close door",
            stateUpdates: [
              { nextState: "closed__flask_mixed__balloon_deflated" },
            ],
            type: "UpdateState",
          },
        ],
      },
      {
        name: "open__flask_mixed__balloon_inflated",
        image: "incubator_open_inflated",
        buttons: [
          {
            icon: "eject_flask_icon",
            title: "Remove flask",
            stateUpdates: [
              { nextState: "open" },
              {
                nextState: "flask_mixed__balloon_red_inflated",
                objectId: "flask3",
              },
            ],
            type: "UpdateState",
            actionName: "EJECT_FLASK_FROM_INCUBATOR",
          },
          {
            icon: "door_close_icon",
            title: "Close door",
            stateUpdates: [
              { nextState: "closed__flask_mixed__balloon_inflated" },
            ],
            type: "UpdateState",
          },
        ],
      },
      {
        name: "open__flask_yeast_sugar_water__balloon_partially_inflated",
        image: "incubator_open_partially_inflated",
        buttons: [
          {
            icon: "eject_flask_icon",
            title: "Remove flask",
            stateUpdates: [
              {
                nextState: "open",
              },
              {
                nextState:
                  "flask_yeast_sugar_water__balloon_red_partially_inflated",
                objectId: "flask3",
              },
            ],
            type: "UpdateState",
            actionName: "EJECT_FLASK_FROM_INCUBATOR",
          },
          {
            icon: "door_close_icon",
            title: "Close door",
            stateUpdates: [
              {
                nextState:
                  "closed__flask_yeast_sugar_water__balloon_partially_inflated",
              },
            ],
            type: "UpdateState",
          },
        ],
      },
      {
        name: "open__flask_yeast_sugar_water__balloon_deflated",
        image: "incubator_open_flask_unmixed",
        buttons: [
          {
            icon: "eject_flask_icon",
            title: "Remove flask",
            stateUpdates: [
              { nextState: "open" },
              {
                nextState: "flask_yeast_sugar_water__balloon_red",
                objectId: "flask3",
              },
            ],
            type: "UpdateState",

            actionName: "EJECT_FLASK_FROM_INCUBATOR",
          },
          {
            icon: "door_close_icon",
            title: "Close door",
            stateUpdates: [
              {
                nextState: "closed__flask_yeast_sugar_water__balloon_deflated",
              },
            ],
            type: "UpdateState",
          },
        ],
      },
      {
        name: "open__flask__balloon_deflated",
        image: "incubator_open_empty_flask",
        buttons: [
          {
            icon: "eject_flask_icon",
            title: "Remove flask",
            stateUpdates: [
              { nextState: "open" },
              {
                nextState: "flask__balloon_red",
                objectId: "flask3",
              },
            ],
            type: "UpdateState",
            actionName: "EJECT_FLASK_FROM_INCUBATOR",
          },
          {
            icon: "door_close_icon",
            title: "Close door",
            stateUpdates: [{ nextState: "closed__flask__balloon_deflated" }],
            type: "UpdateState",
          },
        ],
      },
      {
        name: "open__flask_yeast_water__balloon_deflated",
        image: "incubator_open_no_sugar",
        buttons: [
          {
            icon: "eject_flask_icon",
            title: "Remove flask",
            stateUpdates: [
              { nextState: "open" },
              {
                nextState: "flask_yeast_water__balloon_red",
                objectId: "flask3",
              },
            ],
            type: "UpdateState",
            actionName: "EJECT_FLASK_FROM_INCUBATOR",
          },
          {
            icon: "door_close_icon",
            title: "Close door",
            stateUpdates: [
              { nextState: "closed__flask_yeast_water__balloon_deflated" },
            ],
            type: "UpdateState",
          },
        ],
      },
      {
        name: "open__flask_yeast_sugar__balloon_deflated",
        image: "incubator_open_no_water",
        buttons: [
          {
            icon: "eject_flask_icon",
            title: "Remove flask",
            stateUpdates: [
              { nextState: "open" },
              {
                nextState: "flask_yeast_sugar__balloon_red",
                objectId: "flask3",
              },
            ],
            type: "UpdateState",
            actionName: "EJECT_FLASK_FROM_INCUBATOR",
          },
          {
            icon: "door_close_icon",
            title: "Close door",
            stateUpdates: [
              { nextState: "closed__flask_yeast_sugar__balloon_deflated" },
            ],
            type: "UpdateState",
          },
        ],
      },
      {
        name: "open__flask_sugar_water__balloon_deflated",
        image: "incubator_open_no_yeast",
        buttons: [
          {
            icon: "eject_flask_icon",
            title: "Remove flask",
            stateUpdates: [
              { nextState: "open" },
              {
                nextState: "flask_sugar_water__balloon_red",
                objectId: "flask3",
              },
            ],
            type: "UpdateState",
            actionName: "EJECT_FLASK_FROM_INCUBATOR",
          },
          {
            icon: "door_close_icon",
            title: "Close door",
            stateUpdates: [
              { nextState: "closed__flask_sugar_water__balloon_deflated" },
            ],
            type: "UpdateState",
          },
        ],
      },
      {
        name: "open__flask_sugar__balloon_deflated",
        image: "incubator_open_sugar",
        buttons: [
          {
            icon: "eject_flask_icon",
            title: "Remove flask",
            stateUpdates: [
              { nextState: "open" },
              {
                nextState: "flask_sugar__balloon_red",
                objectId: "flask3",
              },
            ],
            type: "UpdateState",
            actionName: "EJECT_FLASK_FROM_INCUBATOR",
          },
          {
            icon: "door_close_icon",
            title: "Close door",
            stateUpdates: [
              { nextState: "closed__flask_sugar__balloon_deflated" },
            ],
            type: "UpdateState",
          },
        ],
      },
      {
        name: "open__flask_water__balloon_deflated",
        image: "incubator_open_water",
        buttons: [
          {
            icon: "eject_flask_icon",
            title: "Remove flask",
            stateUpdates: [
              { nextState: "open" },

              {
                nextState: "flask_water__balloon_red",
                objectId: "flask3",
              },
            ],
            type: "UpdateState",
            actionName: "EJECT_FLASK_FROM_INCUBATOR",
          },
          {
            icon: "door_close_icon",
            title: "Close door",
            stateUpdates: [
              { nextState: "closed__flask_water__balloon_deflated" },
            ],
            type: "UpdateState",
          },
        ],
      },
      {
        name: "open__flask_yeast__balloon_deflated",
        image: "incubator_open_yeast",
        buttons: [
          {
            icon: "eject_flask_icon",
            title: "Remove flask",
            stateUpdates: [
              { nextState: "open" },
              {
                nextState: "flask_yeast__balloon_red",
                objectId: "flask3",
              },
            ],
            type: "UpdateState",
            actionName: "EJECT_FLASK_FROM_INCUBATOR",
          },
          {
            icon: "door_close_icon",
            title: "Close door",
            stateUpdates: [
              { nextState: "closed__flask_yeast__balloon_deflated" },
            ],
            type: "UpdateState",
          },
        ],
      },
    ],
  },
  {
    name: "refrigerator",
    image: "fridge_closed",
    type: "interactableObject",
    defaultState: "closed",
    states: [
      {
        name: "closed",
        image: "fridge_closed",
        buttons: [
          {
            icon: "door_open_icon",
            title: "Open door",
            stateUpdates: [{ nextState: "open" }],
            type: "UpdateState",
          },
        ],
      },
      {
        name: "closed__flask_mixed__balloon_deflated",
        image: "fridge_closed_flask",
        buttons: [
          {
            icon: "door_open_icon",
            title: "Open door",
            stateUpdates: [
              { nextState: "open__flask_mixed__balloon_deflated" },
            ],
            type: "UpdateState",
          },
        ],
      },
      {
        name: "closed__flask_yeast_sugar_water__balloon_deflated",
        image: "fridge_closed_flask_unmixed",
        buttons: [
          {
            icon: "door_open_icon",
            title: "Open door",
            stateUpdates: [
              { nextState: "open__flask_yeast_sugar_water__balloon_deflated" },
            ],
            type: "UpdateState",
          },
        ],
      },
      {
        name: "closed__flask__balloon_deflated",
        image: "fridge_closed_empty_flask",
        buttons: [
          {
            icon: "door_open_icon",
            title: "Open door",
            stateUpdates: [{ nextState: "open__flask__balloon_deflated" }],
            type: "UpdateState",
          },
        ],
      },
      {
        name: "closed__flask_yeast_water__balloon_deflated",
        image: "fridge_closed_no_sugar",
        buttons: [
          {
            icon: "door_open_icon",
            title: "Open door",
            stateUpdates: [
              { nextState: "open__flask_yeast_water__balloon_deflated" },
            ],
            type: "UpdateState",
          },
        ],
      },
      {
        name: "closed__flask_yeast_sugar__balloon_deflated",
        image: "fridge_closed_no_water",
        buttons: [
          {
            icon: "door_open_icon",
            title: "Open door",
            stateUpdates: [
              { nextState: "open__flask_yeast_sugar__balloon_deflated" },
            ],
            type: "UpdateState",
          },
        ],
      },
      {
        name: "closed__flask_sugar_water__balloon_deflated",
        image: "fridge_closed_no_yeast",
        buttons: [
          {
            icon: "door_open_icon",
            title: "Open door",
            stateUpdates: [
              { nextState: "open__flask_sugar_water__balloon_deflated" },
            ],
            type: "UpdateState",
          },
        ],
      },
      {
        name: "closed__flask_sugar__balloon_deflated",
        image: "fridge_closed_sugar",
        buttons: [
          {
            icon: "door_open_icon",
            title: "Open door",
            stateUpdates: [
              { nextState: "open__flask_sugar__balloon_deflated" },
            ],
            type: "UpdateState",
          },
        ],
      },
      {
        name: "closed__flask_water__balloon_deflated",
        image: "fridge_closed_water",
        buttons: [
          {
            icon: "door_open_icon",
            title: "Open door",
            stateUpdates: [
              { nextState: "open__flask_water__balloon_deflated" },
            ],
            type: "UpdateState",
          },
        ],
      },
      {
        name: "closed__flask_yeast__balloon_deflated",
        image: "fridge_closed_yeast",
        buttons: [
          {
            icon: "door_open_icon",
            title: "Open door",
            stateUpdates: [
              { nextState: "open__flask_yeast__balloon_deflated" },
            ],
            type: "UpdateState",
          },
        ],
      },
      {
        name: "open",
        image: "fridge_open",
        buttons: [
          {
            icon: "door_close_icon",
            title: "Close door",
            stateUpdates: [{ nextState: "closed" }],
            type: "UpdateState",
          },
        ],
      },
      {
        name: "open__flask__balloon_deflated",
        image: "fridge_open_empty_flask",
        buttons: [
          {
            icon: "eject_flask_icon",
            title: "Remove flask",
            stateUpdates: [
              { nextState: "open" },
              {
                nextState: "flask__balloon_blue",
                objectId: "flask1",
              },
            ],
            type: "UpdateState",
            actionName: "EJECT_FLASK_FROM_FRIDGE",
          },
          {
            icon: "door_close_icon",
            title: "Close door",
            stateUpdates: [{ nextState: "closed__flask__balloon_deflated" }],
            type: "UpdateState",
          },
        ],
      },
      {
        name: "open__flask_mixed__balloon_deflated",
        image: "fridge_open_flask",
        buttons: [
          {
            icon: "eject_flask_icon",
            title: "Remove flask",
            stateUpdates: [
              { nextState: "open" },
              {
                nextState: "flask_mixed__balloon_blue",
                objectId: "flask1",
              },
            ],
            type: "UpdateState",
            actionName: "EJECT_FLASK_FROM_FRIDGE",
          },
          {
            icon: "door_close_icon",
            title: "Close door",
            stateUpdates: [
              { nextState: "closed__flask_mixed__balloon_deflated" },
            ],
            type: "UpdateState",
          },
        ],
      },
      {
        name: "open__flask_mixed__balloon_deflated_cooled",
        image: "fridge_open_flask",
        buttons: [
          {
            icon: "eject_flask_icon",
            title: "Remove flask",
            stateUpdates: [
              { nextState: "open" },
              {
                nextState: "flask_mixed__balloon_blue_cooled",
                objectId: "flask1",
              },
            ],
            type: "UpdateState",
            actionName: "EJECT_FLASK_FROM_FRIDGE",
          },
          {
            icon: "door_close_icon",
            title: "Close door",
            stateUpdates: [
              { nextState: "closed__flask_mixed__balloon_deflated" },
            ],
            type: "UpdateState",
          },
        ],
      },
      {
        name: "open__flask_yeast_sugar_water__balloon_deflated",
        image: "fridge_open_flask_unmixed",
        buttons: [
          {
            icon: "eject_flask_icon",
            title: "Remove flask",
            stateUpdates: [
              { nextState: "open" },

              {
                nextState: "flask_yeast_sugar_water__balloon_blue",
                objectId: "flask1",
              },
            ],
            type: "UpdateState",
            actionName: "EJECT_FLASK_FROM_FRIDGE",
          },
          {
            icon: "door_close_icon",
            title: "Close door",
            stateUpdates: [
              {
                nextState: "closed__flask_yeast_sugar_water__balloon_deflated",
              },
            ],
            type: "UpdateState",
          },
        ],
      },
      {
        name: "open__flask_yeast_water__balloon_deflated",
        image: "fridge_open_no_sugar",
        buttons: [
          {
            icon: "eject_flask_icon",
            title: "Remove flask",
            stateUpdates: [
              { nextState: "open" },

              {
                nextState: "flask_yeast_yeast_water__balloon_blue",
                objectId: "flask1",
              },
            ],
            type: "UpdateState",
            actionName: "EJECT_FLASK_FROM_FRIDGE",
          },
          {
            icon: "door_close_icon",
            title: "Close door",
            stateUpdates: [
              { nextState: "closed__flask_yeast_water__balloon_deflated" },
            ],
            type: "UpdateState",
          },
        ],
      },
      {
        name: "open__flask_yeast_sugar__balloon_deflated",
        image: "fridge_open_no_water",
        buttons: [
          {
            icon: "eject_flask_icon",
            title: "Remove flask",
            stateUpdates: [
              { nextState: "open" },
              {
                nextState: "flask_yeast_sugar__balloon_blue",
                objectId: "flask1",
              },
            ],
            type: "UpdateState",
            actionName: "EJECT_FLASK_FROM_FRIDGE",
          },
          {
            icon: "door_close_icon",
            title: "Close door",
            stateUpdates: [
              { nextState: "closed__flask_yeast_sugar__balloon_deflated" },
            ],
            type: "UpdateState",
          },
        ],
      },
      {
        name: "open__flask_sugar_water__balloon_deflated",
        image: "fridge_open_no_yeast",
        buttons: [
          {
            icon: "eject_flask_icon",
            title: "Remove flask",
            stateUpdates: [
              { nextState: "open" },
              {
                nextState: "flask_sugar_water__balloon_blue",
                objectId: "flask1",
              },
            ],
            type: "UpdateState",
            actionName: "EJECT_FLASK_FROM_FRIDGE",
          },
          {
            icon: "door_close_icon",
            title: "Close door",
            stateUpdates: [
              { nextState: "closed__flask_sugar_water__balloon_deflated" },
            ],
            type: "UpdateState",
          },
        ],
      },
      {
        name: "open__flask_sugar__balloon_deflated",
        image: "fridge_open_sugar",
        buttons: [
          {
            icon: "eject_flask_icon",
            title: "Remove flask",
            stateUpdates: [
              { nextState: "open" },
              {
                nextState: "flask_sugar__balloon_blue",
                objectId: "flask1",
              },
            ],
            type: "UpdateState",
            actionName: "EJECT_FLASK_FROM_FRIDGE",
          },
          {
            icon: "door_close_icon",
            title: "Close door",
            stateUpdates: [
              { nextState: "closed__flask_sugar__balloon_deflated" },
            ],
            type: "UpdateState",
          },
        ],
      },
      {
        name: "open__flask_water__balloon_deflated",
        image: "fridge_open_water",
        buttons: [
          {
            icon: "eject_flask_icon",
            title: "Remove flask",
            stateUpdates: [
              { nextState: "open" },
              {
                nextState: "flask_water__balloon_blue",
                objectId: "flask1",
              },
            ],
            type: "UpdateState",
            actionName: "EJECT_FLASK_FROM_FRIDGE",
          },
          {
            icon: "door_close_icon",
            title: "Close door",
            stateUpdates: [
              { nextState: "closed__flask_water__balloon_deflated" },
            ],
            type: "UpdateState",
          },
        ],
      },
      {
        name: "open__flask_yeast__balloon_deflated",
        image: "fridge_open_yeast",
        buttons: [
          {
            icon: "eject_flask_icon",
            title: "Remove flask",
            stateUpdates: [
              { nextState: "open" },
              {
                nextState: "flask_yeast__balloon_blue",
                objectId: "flask1",
              },
            ],
            type: "UpdateState",
            actionName: "EJECT_FLASK_FROM_FRIDGE",
          },
          {
            icon: "door_close_icon",
            title: "Close door",
            stateUpdates: [
              { nextState: "closed__flask_yeast__balloon_deflated" },
            ],
            type: "UpdateState",
          },
        ],
      },
    ],
  },
  {
    name: "small_water_beaker",
    image: "small_water_beaker",
    type: "controllableObject",
    defaultState: "water",
    states: [
      {
        name: "water",
        image: "small_water_beaker",
      },
    ],
  },
  {
    name: "red_balloon",
    image: "red_balloon",
    type: "controllableObject",
    defaultState: "shown",
    states: [
      {
        name: "hidden",
        image: "",
      },
      {
        name: "shown",
        image: "red_balloon",
      },
    ],
  },
  {
    name: "blue_balloon",
    image: "blue_balloon",
    type: "controllableObject",
    defaultState: "shown",
    states: [
      {
        name: "hidden",
        image: "",
      },
      {
        name: "shown",
        image: "blue_balloon",
      },
    ],
  },
  {
    name: "yellow_balloon",
    image: "yellow_balloon",
    type: "controllableObject",
    defaultState: "shown",
    states: [
      {
        name: "hidden",
        image: "",
      },
      {
        name: "shown",
        image: "yellow_balloon",
      },
    ],
  },
  {
    name: "sugar_spoon",
    image: "blue_spoon",
    type: "controllableObject",
    defaultState: "hidden",
    states: [
      {
        name: "hidden",
        image: "",
      },
      {
        name: "empty",
        image: "blue_spoon",
      },
      {
        name: "filled",
        image: "blue_spoon_w_sugar",
      },

      {
        name: "emptied",
        image: "blue_spoon",
      },
    ],
  },
  {
    name: "yeast_spoon",
    image: "purple_spoon",
    type: "controllableObject",
    defaultState: "hidden",
    states: [
      {
        name: "hidden",
        image: "",
      },
      {
        name: "empty",
        image: "purple_spoon",
      },
      {
        name: "filled",
        image: "purple_spoon_w_yeast",
      },
      {
        name: "emptied",
        image: "purple_spoon",
      },
    ],
  },
  {
    name: "flask",
    image: "flask",
    type: "controllableObject",
    defaultState: "empty",
    states: [
      {
        name: "hidden",
        image: "",
      },
      {
        name: "empty",
        image: "flask",
      },
      {
        name: "flask_yeast_sugar_water__balloon_blue",
        image: "flask_blue_all",
        buttons: [
          {
            icon: "shake_flask_icon",
            title: "Shake flask",
            stateUpdates: [{ nextState: "flask_mixed__balloon_blue_animated" }],
            type: "UpdateState",
            actionName: "FLASK_SHAKEN",
          },
        ],
      },
      {
        name: "flask__balloon_blue",
        image: "flask_blue_empty",
        buttons: [
          {
            icon: "eject_balloon_icon",
            title: "Remove balloon",
            stateUpdates: [{ nextState: "empty" }],
            type: "UpdateState",
            actionName: "EJECT_BALLOON",
          },
        ],
      },
      {
        name: "flask_mixed__balloon_blue_animated",
        image: "flask_blue_mixed",
        animation: {
          name: "shake",
          duration: 0.3,
          iterationCount: 2,
          _10: {
            rotate: "y 0deg",
          },
          _20: {
            rotate: "y 12deg",
          },
          _30: {
            rotate: "y 0deg",
          },
          _40: {
            rotate: "y -12deg",
          },
          _50: {
            rotate: "y 0deg",
          },
          _60: {
            rotate: "y 0deg",
          },
          _70: {
            rotate: "y 12deg",
          },
          _80: {
            rotate: "y 0deg",
          },
          _90: {
            rotate: "y -12deg",
          },
          _100: {
            rotate: "y 0deg",
          },
        },
      },
      {
        name: "flask_mixed__balloon_blue",
        image: "flask_blue_mixed",
      },
      {
        name: "flask_mixed__balloon_blue_cooled",
        image: "flask_blue_mixed",
        label: {
          text: "Flask 1 (cold)",
        },
      },
      {
        name: "flask_sugar_water__balloon_blue",
        image: "flask_blue_sugar_and_water",
        buttons: [
          {
            icon: "eject_balloon_icon",
            title: "Remove balloon",
            stateUpdates: [{ nextState: "flask_sugar_water" }],
            type: "UpdateState",
            actionName: "EJECT_BALLOON",
          },
        ],
      },
      {
        name: "flask_yeast_sugar__balloon_blue",
        image: "flask_blue_sugar_and_yeast",
        buttons: [
          {
            icon: "eject_balloon_icon",
            title: "Remove balloon",
            stateUpdates: [{ nextState: "flask_yeast_sugar" }],
            type: "UpdateState",
            actionName: "EJECT_BALLOON",
          },
        ],
      },
      {
        name: "flask_sugar__balloon_blue",
        image: "flask_blue_sugar",
        buttons: [
          {
            icon: "eject_balloon_icon",
            title: "Remove balloon",
            stateUpdates: [{ nextState: "flask_sugar" }],
            type: "UpdateState",
            actionName: "EJECT_BALLOON",
          },
        ],
      },
      {
        name: "flask_water__balloon_blue",
        image: "flask_blue_water",
        buttons: [
          {
            icon: "eject_balloon_icon",
            title: "Remove balloon",
            stateUpdates: [{ nextState: "flask_water" }],
            type: "UpdateState",
            actionName: "EJECT_BALLOON",
          },
        ],
      },
      {
        name: "flask_yeast__balloon_blue",
        image: "flask_blue_yeast",
        buttons: [
          {
            icon: "eject_balloon_icon",
            title: "Remove balloon",
            stateUpdates: [{ nextState: "flask_yeast" }],
            type: "UpdateState",
            actionName: "EJECT_BALLOON",
          },
        ],
      },
      {
        name: "flask_yeast_water__balloon_blue",
        image: "flask_blue_yeast_and_water",
        buttons: [
          {
            icon: "eject_balloon_icon",
            title: "Remove balloon",
            stateUpdates: [{ nextState: "flask_yeast_water" }],
            type: "UpdateState",
            actionName: "EJECT_BALLOON",
          },
        ],
      },
      {
        name: "flask_yeast_sugar_water__balloon_red",
        image: "flask_red_all",
        buttons: [
          {
            icon: "shake_flask_icon",
            title: "Shake flask",
            stateUpdates: [{ nextState: "flask_mixed__balloon_red_animated" }],
            type: "UpdateState",
            actionName: "FLASK_SHAKEN",
          },
        ],
      },
      {
        name: "flask_yeast_sugar_water__balloon_red_partially_inflated",
        image: "flask_red_partially_inflated",
        label: {
          text: "Flask 3 (warm)",
        },
      },
      {
        name: "flask__balloon_red",
        image: "flask_red_empty",
        buttons: [
          {
            icon: "eject_balloon_icon",
            title: "Remove balloon",
            stateUpdates: [{ nextState: "empty" }],
            type: "UpdateState",
            actionName: "EJECT_BALLOON",
          },
        ],
      },
      {
        name: "flask_mixed__balloon_red_animated",
        image: "flask_red_mixed",
        animation: {
          name: "shake",
          duration: 0.3,
          iterationCount: 2,
          _10: {
            rotate: "y 0deg",
          },
          _20: {
            rotate: "y 12deg",
          },
          _30: {
            rotate: "y 0deg",
          },
          _40: {
            rotate: "y -12deg",
          },
          _50: {
            rotate: "y 0deg",
          },
          _60: {
            rotate: "y 0deg",
          },
          _70: {
            rotate: "y 12deg",
          },
          _80: {
            rotate: "y 0deg",
          },
          _90: {
            rotate: "y -12deg",
          },
          _100: {
            rotate: "y 0deg",
          },
        },
      },
      {
        name: "flask_mixed__balloon_red",
        image: "flask_red_mixed",
      },
      {
        name: "flask_mixed__balloon_red_inflated",
        image: "flask_red_inflated",
        label: {
          text: "Flask 3 (warm)",
        },
      },
      {
        name: "flask_sugar_water__balloon_red",
        image: "flask_red_sugar_and_water",
        buttons: [
          {
            icon: "eject_balloon_icon",
            title: "Remove balloon",
            stateUpdates: [{ nextState: "flask_sugar_water" }],
            type: "UpdateState",
            actionName: "EJECT_BALLOON",
          },
        ],
      },
      {
        name: "flask_yeast_sugar__balloon_red",
        image: "flask_red_sugar_and_yeast",
        buttons: [
          {
            icon: "eject_balloon_icon",
            title: "Remove balloon",
            stateUpdates: [{ nextState: "flask_yeast_sugar" }],
            type: "UpdateState",
            actionName: "EJECT_BALLOON",
          },
        ],
      },
      {
        name: "flask_sugar__balloon_red",
        image: "flask_red_sugar",
        buttons: [
          {
            icon: "eject_balloon_icon",
            title: "Remove balloon",
            stateUpdates: [{ nextState: "flask_sugar" }],
            type: "UpdateState",
            actionName: "EJECT_BALLOON",
          },
        ],
      },
      {
        name: "flask_water__balloon_red",
        image: "flask_red_water",
        buttons: [
          {
            icon: "eject_balloon_icon",
            title: "Remove balloon",
            stateUpdates: [{ nextState: "flask_water" }],
            type: "UpdateState",
            actionName: "EJECT_BALLOON",
          },
        ],
      },
      {
        name: "flask_yeast__balloon_red",
        image: "flask_red_yeast",
        buttons: [
          {
            icon: "eject_balloon_icon",
            title: "Remove balloon",
            stateUpdates: [{ nextState: "flask_yeast" }],
            type: "UpdateState",
            actionName: "EJECT_BALLOON",
          },
        ],
      },
      {
        name: "flask_yeast_water__balloon_red",
        image: "flask_red_yeast_and_water",
        buttons: [
          {
            icon: "eject_balloon_icon",
            title: "Remove balloon",
            stateUpdates: [{ nextState: "flask_yeast_water" }],
            type: "UpdateState",
            actionName: "EJECT_BALLOON",
          },
        ],
      },
      {
        name: "flask_red_inflated",
        image: "flask_red_inflated",
      },
      {
        name: "flask_red_partially_inflated",
        image: "flask_red_partially_inflated",
      },
      {
        name: "flask_yeast_sugar_water__balloon_yellow",
        image: "flask_yellow_all",
        buttons: [
          {
            icon: "shake_flask_icon",
            title: "Shake flask",
            stateUpdates: [{ nextState: "flask_mixed__balloon_yellow" }],
            type: "UpdateState",
            actionName: "FLASK_SHAKEN",
          },
        ],
      },
      {
        name: "flask__balloon_yellow",
        image: "flask_yellow_empty",
        buttons: [
          {
            icon: "eject_balloon_icon",
            title: "Remove balloon",
            stateUpdates: [{ nextState: "empty" }],
            type: "UpdateState",
            actionName: "EJECT_BALLOON",
          },
        ],
      },
      {
        name: "flask_mixed__balloon_yellow",
        image: "flask_yellow_mixed",
        animation: {
          name: "shake",
          duration: 0.3,
          interationCount: 2,
          _10: {
            rotate: "y 0deg",
          },
          _20: {
            rotate: "y 12deg",
          },
          _30: {
            rotate: "y 0deg",
          },
          _40: {
            rotate: "y -12deg",
          },
          _50: {
            rotate: "y 0deg",
          },
          _60: {
            rotate: "y 0deg",
          },
          _70: {
            rotate: "y 12deg",
          },
          _80: {
            rotate: "y 0deg",
          },
          _90: {
            rotate: "y -12deg",
          },
          _100: {
            rotate: "y 0deg",
          },
        },
      },
      {
        name: "flask_mixed__balloon_yellow_inflated",
        image: "flask_yellow_inflated",
        label: {
          text: "Flask 2 (room)",
        },
      },
      {
        name: "flask_sugar_water__balloon_yellow",
        image: "flask_yellow_sugar_and_water",
        buttons: [
          {
            icon: "eject_balloon_icon",
            title: "Remove balloon",
            stateUpdates: [{ nextState: "flask_sugar_water" }],
            type: "UpdateState",
            actionName: "EJECT_BALLOON",
          },
        ],
      },
      {
        name: "flask_yeast_sugar__balloon_yellow",
        image: "flask_yellow_sugar_and_yeast",
        buttons: [
          {
            icon: "eject_balloon_icon",
            title: "Remove balloon",
            stateUpdates: [{ nextState: "flask_yeast_sugar" }],
            type: "UpdateState",
            actionName: "EJECT_BALLOON",
          },
        ],
      },
      {
        name: "flask_sugar__balloon_yellow",
        image: "flask_yellow_sugar",
        buttons: [
          {
            icon: "eject_balloon_icon",
            title: "Remove balloon",
            stateUpdates: [{ nextState: "flask_sugar" }],
            type: "UpdateState",
            actionName: "EJECT_BALLOON",
          },
        ],
      },
      {
        name: "flask_water__balloon_yellow",
        image: "flask_yellow_water",
        buttons: [
          {
            icon: "eject_balloon_icon",
            title: "Remove balloon",
            stateUpdates: [{ nextState: "flask_water" }],
            type: "UpdateState",
            actionName: "EJECT_BALLOON",
          },
        ],
      },
      {
        name: "flask_yeast__balloon_yellow",
        image: "flask_yellow_yeast",
        buttons: [
          {
            icon: "eject_balloon_icon",
            title: "Remove balloon",
            stateUpdates: [{ nextState: "flask_yeast" }],
            type: "UpdateState",
            actionName: "EJECT_BALLOON",
          },
        ],
      },
      {
        name: "flask_yeast_water__balloon_yellow",
        image: "flask_yellow_yeast_and_water",
        buttons: [
          {
            icon: "eject_balloon_icon",
            title: "Remove balloon",
            stateUpdates: [{ nextState: "flask_yeast_water" }],
            type: "UpdateState",
            actionName: "EJECT_BALLOON",
          },
        ],
      },
      {
        name: "flask_yellow_inflated",
        image: "flask_yellow_inflated",
      },
      {
        name: "empty",
        image: "flask",
      },
      {
        name: "flask_yeast_sugar_water",
        image: "flask_all",
      },
      {
        name: "flask_mixed",
        image: "flask_mixed",
      },
      {
        name: "flask_sugar",
        image: "flask_sugar",
      },
      {
        name: "flask_water",
        image: "flask_water",
      },
      {
        name: "flask_yeast",
        image: "flask_yeast",
      },
      {
        name: "flask_yeast_sugar",
        image: "flask_sugar_and_yeast",
      },
      {
        name: "flask_sugar_water",
        image: "flask_sugar_and_water",
      },
      {
        name: "flask_yeast_water",
        image: "flask_yeast_and_water",
      },
    ],
  },
];

export default objects;
